var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g2, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4HeadphonesEarbuds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350.839 459.464C354.127 457.642 357.066 457.45 359.258 458.553L353.828 455.484C353.728 455.436 353.629 455.388 353.529 455.341L353.479 455.293C351.288 454.19 348.349 454.381 345.111 456.204C338.436 459.944 333.006 468.959 333.006 476.392L333.006 490.633L338.735 493.846L338.735 479.604C338.735 472.22 344.164 463.205 350.839 459.464Z",
    fill: "#85969E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.212 477.207L362.941 480.42L362.941 466.178C362.941 460.808 360.101 457.739 356.017 457.882C356.764 459.225 357.162 460.903 357.162 462.965L357.212 477.207Z",
    fill: "#344045"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M329.667 486.078C329.667 490.154 332.655 495.141 336.341 497.203C340.028 499.265 343.016 497.587 343.016 493.511C343.016 489.435 340.028 484.448 336.341 482.386C332.655 480.324 329.667 481.955 329.667 486.078Z",
    fill: "#543F3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M343.018 493.463C343.018 489.387 340.029 484.4 336.343 482.338C334.55 481.331 332.906 481.235 331.71 481.858L332.458 481.331C333.703 480.276 335.596 480.228 337.688 481.426C341.374 483.488 344.363 488.475 344.363 492.551C344.363 494.278 343.865 495.524 342.968 496.292C342.769 496.484 342.52 496.627 342.271 496.771L341.673 497.203C342.52 496.388 343.018 495.141 343.018 493.463Z",
    fill: "#C8B2A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M327.277 488.476C327.277 492.025 329.868 496.34 333.056 498.115C336.244 499.889 338.834 498.45 338.834 494.902C338.834 491.353 336.244 487.038 333.056 485.263C329.818 483.489 327.277 484.928 327.277 488.476Z",
    fill: "#543F3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M333.004 485.263C331.41 484.352 329.966 484.304 328.919 484.879L331.41 483.488C332.456 482.577 334.1 482.529 335.943 483.536C339.131 485.311 341.721 489.626 341.721 493.175C341.721 494.661 341.273 495.764 340.526 496.436C340.327 496.579 340.127 496.723 339.928 496.819L337.587 498.162C338.384 497.491 338.832 496.388 338.832 494.853C338.782 491.353 336.192 487.037 333.004 485.263Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M353.828 455.533C353.728 455.485 353.629 455.437 353.529 455.389L353.479 455.341C351.288 454.238 348.349 454.43 345.111 456.252C338.436 459.993 333.006 469.008 333.006 476.44L333.006 482.866C333.853 482.77 334.849 483.01 335.945 483.585C336.991 484.161 337.938 484.976 338.785 485.983L338.785 479.701C338.785 472.268 344.214 463.205 350.889 459.513C354.177 457.691 357.116 457.499 359.308 458.602L353.828 455.533Z",
    fill: "#DECCC2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M354.029 473.515C354.029 477.063 356.619 481.379 359.807 483.153C362.995 484.927 365.585 483.489 365.585 479.94C365.585 476.392 362.995 472.076 359.807 470.302C356.619 468.576 354.029 470.014 354.029 473.515Z",
    fill: "#E3E3E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M359.806 470.35C358.212 469.439 356.768 469.391 355.722 469.966L358.212 468.576C359.258 467.665 360.902 467.617 362.745 468.624C365.933 470.398 368.524 474.714 368.524 478.262C368.524 479.749 368.075 480.851 367.328 481.523C367.129 481.667 366.93 481.81 366.73 481.906L364.389 483.249C365.186 482.578 365.634 481.475 365.634 479.94C365.585 476.392 362.994 472.076 359.806 470.35Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M363.412 485.246C366.008 483.803 366.006 479.119 363.406 474.784C360.807 470.45 356.594 468.106 353.997 469.549C351.4 470.992 351.402 475.676 354.002 480.011C356.602 484.346 360.815 486.689 363.412 485.246Z",
    fill: "#543F3E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M365.383 481.091C365.383 477.015 362.394 472.028 358.708 469.966C356.915 468.959 355.271 468.863 354.076 469.487L354.823 468.959C356.068 467.904 357.961 467.856 360.053 469.055C363.739 471.117 366.728 476.104 366.728 480.18C366.728 481.906 366.23 483.153 365.333 483.92C365.134 484.112 364.885 484.256 364.636 484.4L364.038 484.831C364.885 484.016 365.383 482.769 365.383 481.091Z",
    fill: "#C8B2A6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M357.212 468.144C358.109 468.144 359.055 468.432 360.101 469.007C361.147 469.583 362.094 470.398 362.941 471.309L362.941 466.178C362.941 460.808 360.101 457.739 356.017 457.882C356.764 459.225 357.162 460.903 357.162 462.965L357.212 468.144Z",
    fill: "#543F3E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M352.683 474.042C352.683 477.782 355.373 482.29 358.76 484.16C362.097 486.03 364.837 484.496 364.837 480.803C364.837 477.063 362.147 472.556 358.76 470.685C355.373 468.815 352.683 470.302 352.683 474.042Z",
    fill: "#8D807F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M353.127 474.281C353.127 477.686 355.618 481.858 358.706 483.584C361.794 485.311 364.285 483.92 364.285 480.467C364.285 477.063 361.794 472.891 358.706 471.165C355.618 469.486 353.127 470.877 353.127 474.281Z",
    fill: "#543F3E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M354.427 475.001C354.427 477.639 356.32 480.803 358.711 482.146C361.052 483.441 362.995 482.386 362.995 479.748C362.995 477.111 361.102 473.946 358.711 472.604C356.37 471.357 354.427 472.412 354.427 475.001Z",
    fill: "#8D807F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M355.519 475.625C355.519 477.591 356.963 479.94 358.707 480.899C360.45 481.858 361.895 481.091 361.895 479.125C361.895 477.159 360.45 474.809 358.707 473.85C356.963 472.891 355.519 473.707 355.519 475.625Z",
    fill: "#776353"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M359.954 480.132C358.211 479.173 356.766 476.775 356.766 474.857C356.766 474.282 356.866 473.85 357.115 473.467C356.169 473.563 355.571 474.33 355.571 475.625C355.571 477.591 357.015 479.94 358.759 480.899C360.004 481.571 361.1 481.379 361.598 480.516C361.1 480.564 360.552 480.468 359.954 480.132Z",
    fill: "#453130"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M359.253 458.553C357.062 457.45 354.123 457.642 350.835 459.464C344.16 463.205 338.73 472.22 338.73 479.652L338.73 485.934C338.681 485.886 338.681 485.838 338.631 485.79C338.98 486.174 339.278 486.558 339.577 486.989L339.577 479.988C339.577 472.555 345.007 463.492 351.682 459.8C354.969 457.978 357.908 457.786 360.1 458.889L359.253 458.553Z",
    fill: "#543F3E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M336.565 497.635C338.543 496.536 338.551 492.986 336.584 489.707C334.617 486.427 331.42 484.659 329.442 485.758C327.465 486.857 327.456 490.407 329.423 493.687C331.39 496.966 334.588 498.734 336.565 497.635Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1949_54976)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.715,
    y: 214.476,
    width: 65.9128,
    height: 60.7767,
    transform: "rotate(-0.922495 559.715 214.476)",
    fill: "url(#paint0_linear_1949_54976)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M582.971 256.296C582.971 256.249 581.409 251.603 580.879 249.274C580.349 246.945 580 244.085 580 244.059V244.006C579.988 236.47 585.458 231 592.994 231C596.442 231.004 599.748 232.375 602.186 234.814C604.625 237.252 605.996 240.558 606 244.006C605.997 245.059 605.983 246.173 605.791 247.208C605.498 248.482 603.149 255.974 603.062 256.296L602.408 256.109C602.428 256.03 604.57 248.199 604.849 246.953C605.027 245.981 605.119 244.995 605.124 244.006C605.121 240.79 603.842 237.707 601.568 235.433C599.293 233.16 596.21 231.881 592.994 231.879C585.863 231.879 580.879 236.86 580.867 243.979C580.905 244.272 581.242 246.909 581.746 249.083C582.271 251.386 583.627 256.057 583.639 256.115L582.971 256.296Z",
    fill: "url(#paint1_radial_1949_54976)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M583.472 255.128C583.419 254.963 582.168 251.078 581.673 248.899C581.178 246.719 580.835 244.058 580.835 244.032V243.979C580.835 236.936 585.951 231.823 592.994 231.823C596.217 231.826 599.308 233.108 601.587 235.387C603.867 237.666 605.149 240.756 605.153 243.979C605.15 244.962 605.058 245.943 604.878 246.909C604.614 248.099 602.765 254.82 602.686 255.113L601.839 254.881C601.86 254.811 603.759 247.894 604.019 246.725C604.185 245.819 604.27 244.9 604.274 243.979C604.27 240.989 603.081 238.122 600.966 236.008C598.851 233.894 595.984 232.705 592.994 232.702C586.364 232.702 581.714 237.325 581.714 243.953C581.749 244.246 582.066 246.684 582.526 248.705C583.012 250.847 584.283 254.82 584.304 254.858L583.472 255.128Z",
    fill: "url(#paint2_radial_1949_54976)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M598.186 232.852C596.517 232.151 594.719 231.805 592.909 231.838C591.101 231.802 589.304 232.143 587.635 232.84C584.412 234.12 582.408 237.275 581.893 238.756C581.893 238.756 582.654 238.826 583.484 237.959C584.313 237.091 586.522 233.757 592.909 233.751C599.296 233.745 601.505 237.112 602.335 237.973C603.164 238.835 603.925 238.77 603.925 238.77C603.455 237.528 601.403 234.132 598.186 232.852Z",
    fill: "url(#paint3_radial_1949_54976)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M602.581 247.425L599.488 257.956C599.242 257.868 598.969 257.822 598.707 257.829C598.224 257.829 596.853 257.627 596.61 257.023C596.366 256.42 599 247.826 599.15 247.223C599.299 246.619 600.029 246.376 600.682 246.657C601.336 246.939 602.458 247.302 602.581 247.425Z",
    fill: "url(#paint4_radial_1949_54976)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M602.581 247.425L599.488 257.956C599.242 257.868 598.969 257.822 598.707 257.829C598.224 257.829 596.853 257.627 596.61 257.023C596.366 256.42 599 247.826 599.15 247.223C599.299 246.619 600.029 246.376 600.682 246.657C601.336 246.939 602.458 247.302 602.581 247.425Z",
    fill: "url(#paint5_radial_1949_54976)",
    fillOpacity: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M602.581 247.425L599.488 257.956C599.242 257.868 598.969 257.822 598.707 257.829C598.224 257.829 596.853 257.627 596.61 257.023C596.366 256.42 599 247.826 599.15 247.223C599.299 246.619 600.029 246.376 600.682 246.657C601.336 246.939 602.458 247.302 602.581 247.425Z",
    fill: "url(#paint6_linear_1949_54976)",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M602.581 247.425C602.986 247.629 603.359 247.892 603.688 248.204C603.988 248.512 604.211 248.887 604.339 249.297C604.371 249.449 602.253 256.639 602.185 256.988C602.118 257.337 601.306 257.803 600.931 257.964C600.304 258.257 599.481 257.964 599.481 257.964L602.581 247.425Z",
    fill: "url(#paint7_linear_1949_54976)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M602.581 247.425C602.986 247.629 603.359 247.892 603.688 248.204C603.988 248.512 604.211 248.887 604.339 249.297C604.371 249.449 602.253 256.639 602.185 256.988C602.118 257.337 601.306 257.803 600.931 257.964C600.304 258.257 599.481 257.964 599.481 257.964L602.581 247.425Z",
    fill: "url(#paint8_linear_1949_54976)",
    fillOpacity: 0.16
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M583.211 247.425L586.317 257.952C586.563 257.864 586.823 257.822 587.085 257.829C587.568 257.829 588.939 257.627 589.182 257.023C589.426 256.42 586.792 247.826 586.642 247.223C586.493 246.619 585.763 246.376 585.11 246.657C584.456 246.939 583.334 247.302 583.211 247.425Z",
    fill: "url(#paint9_radial_1949_54976)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M583.211 247.425L586.317 257.952C586.563 257.864 586.823 257.822 587.085 257.829C587.568 257.829 588.939 257.627 589.182 257.023C589.426 256.42 586.792 247.826 586.642 247.223C586.493 246.619 585.763 246.376 585.11 246.657C584.456 246.939 583.334 247.302 583.211 247.425Z",
    fill: "url(#paint10_radial_1949_54976)",
    fillOpacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M583.211 247.425L586.317 257.952C586.563 257.864 586.823 257.822 587.085 257.829C587.568 257.829 588.939 257.627 589.182 257.023C589.426 256.42 586.792 247.826 586.642 247.223C586.493 246.619 585.763 246.376 585.11 246.657C584.456 246.939 583.334 247.302 583.211 247.425Z",
    fill: "url(#paint11_linear_1949_54976)",
    fillOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M583.212 247.425C582.806 247.629 582.433 247.892 582.104 248.204C581.804 248.512 581.581 248.887 581.454 249.297C581.421 249.449 583.54 256.639 583.607 256.988C583.675 257.337 584.486 257.803 584.861 257.964C585.488 258.257 586.348 257.964 586.348 257.964L583.212 247.425Z",
    fill: "url(#paint12_linear_1949_54976)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M583.212 247.425C582.806 247.629 582.433 247.892 582.104 248.204C581.804 248.512 581.581 248.887 581.454 249.297C581.421 249.449 583.54 256.639 583.607 256.988C583.675 257.337 584.486 257.803 584.861 257.964C585.488 258.257 586.348 257.964 586.348 257.964L583.212 247.425Z",
    fill: "url(#paint13_linear_1949_54976)",
    fillOpacity: 0.16
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M604.641 251.064C604.641 251.064 605.988 251.507 605.244 254.155C604.5 256.804 603.059 256.294 603.059 256.294L604.641 251.064Z",
    fill: "url(#paint14_linear_1949_54976)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M581.402 251.064C581.402 251.064 580.054 251.507 580.798 254.155C581.542 256.804 582.984 256.294 582.984 256.294L581.402 251.064Z",
    fill: "url(#paint15_linear_1949_54976)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M603.694 256.169C603.994 255.763 604.381 254.852 604.677 253.824C604.943 252.897 605.101 252.007 605.093 251.486C605.115 251.504 605.139 251.524 605.157 251.54C605.154 252.072 604.997 252.94 604.738 253.839C604.454 254.829 604.09 255.711 603.794 256.145C603.769 256.151 603.743 256.158 603.74 256.158C603.737 256.158 603.713 256.165 603.694 256.169Z",
    fill: "url(#paint16_linear_1949_54976)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M580.077 244.77V244.623H580.978L581.768 244.477L581.79 244.618L580.982 244.77L580.077 244.77Z",
    fill: "url(#paint17_linear_1949_54976)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M580.282 244.626H580.39L580.628 244.624L580.866 244.626L580.975 244.628L580.866 244.63L580.628 244.632L580.39 244.63L580.282 244.626Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M605.988 244.77V244.623H605.063L604.273 244.477L604.266 244.623L605.06 244.77H605.988Z",
    fill: "url(#paint18_linear_1949_54976)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M605.76 244.626H605.652L605.414 244.624L605.176 244.626L605.067 244.628L605.176 244.63L605.414 244.632L605.652 244.63L605.76 244.626Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M582.33 256.169C582.029 255.763 581.642 254.852 581.347 253.824C581.081 252.897 580.922 252.007 580.93 251.486C580.909 251.504 580.885 251.524 580.866 251.54C580.869 252.072 581.027 252.94 581.285 253.839C581.571 254.829 581.933 255.711 582.231 256.145C582.256 256.151 582.282 256.158 582.285 256.158C582.288 256.158 582.311 256.165 582.33 256.169Z",
    fill: "url(#paint19_linear_1949_54976)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M585.756 258.193L585.784 258.197L585.756 258.193Z",
    fill: "#212121"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M585.922 258.217L585.864 258.209C585.889 258.214 585.912 258.217 585.922 258.217Z",
    fill: "#212121"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M585.863 258.21L585.785 258.198C585.807 258.202 585.837 258.206 585.864 258.21L585.863 258.21Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M583.559 253.269L583.53 253.16C582.97 251.14 582.391 249.052 582.34 248.005L582.28 248.054C582.346 249.122 582.918 251.182 583.471 253.176L583.501 253.285C584.073 255.35 584.592 257.136 585.111 258.032L585.19 258.044C584.664 257.168 584.14 255.361 583.559 253.269Z",
    fill: "url(#paint20_linear_1949_54976)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M582.94 248.065L582.955 248.052L582.94 248.065Z",
    fill: "url(#paint21_linear_1949_54976)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M583.055 247.97C583.048 247.976 583.032 247.989 583.015 248.003L583.055 247.97Z",
    fill: "url(#paint22_linear_1949_54976)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M583.015 248.004L582.955 248.054L583.015 248.005V248.004Z",
    fill: "url(#paint23_linear_1949_54976)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M583.015 248.004L582.955 248.054L583.015 248.005V248.004Z",
    fill: "url(#paint24_linear_1949_54976)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M600.365 258.193L600.337 258.197L600.365 258.193Z",
    fill: "#212121"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M600.199 258.217L600.257 258.209C600.233 258.214 600.21 258.217 600.199 258.217Z",
    fill: "#212121"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M600.258 258.21L600.336 258.198C600.314 258.202 600.285 258.206 600.258 258.21L600.258 258.21Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M602.305 253.304L602.335 253.195C602.888 251.179 603.459 249.096 603.51 248.051L603.568 248.1C603.503 249.165 602.94 251.221 602.394 253.211L602.365 253.32C601.8 255.381 601.288 257.163 600.775 258.057L600.698 258.069C601.215 257.195 601.732 255.391 602.305 253.304Z",
    fill: "url(#paint25_linear_1949_54976)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M603.603 248.065L603.589 248.052C603.598 248.061 603.603 248.065 603.603 248.065Z",
    fill: "url(#paint26_linear_1949_54976)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M603.53 248.004L603.59 248.054L603.53 248.005V248.004Z",
    fill: "url(#paint27_linear_1949_54976)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M600.674 258.193L600.646 258.197L600.674 258.193Z",
    fill: "#212121"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M600.509 258.217L600.566 258.209C600.541 258.214 600.518 258.217 600.509 258.217Z",
    fill: "#212121"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M600.566 258.21L600.644 258.198C600.623 258.202 600.593 258.206 600.566 258.21L600.566 258.21Z",
    fill: "#212121"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1949_54976)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 591.829,
    cy: 214.455,
    r: 2.56803,
    transform: "rotate(6.51456 591.829 214.455)",
    fill: "#FFA800"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 591.829,
    cy: 214.455,
    r: 1.71202,
    transform: "rotate(6.51456 591.829 214.455)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1949_54976",
    x: 555.715,
    y: 213.415,
    width: 74.8828,
    height: 69.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1949_54976"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1949_54976",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1949_54976",
    x: 586.261,
    y: 209.887,
    width: 11.1362,
    height: 11.1365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.498333 0 0 0 0 0.291667 0 0 0 0 0.625 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1949_54976"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1949_54976",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1949_54976",
    x1: 592.671,
    y1: 214.476,
    x2: 592.671,
    y2: 275.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD75C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1949_54976",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(592.994 243.672) scale(13.0059)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948166,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960479,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985918,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99372,
    stopColor: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1949_54976",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(592.994 243.475) scale(12.1562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123178,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478164,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.920046,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1949_54976",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(592.88 245.064) rotate(-90) scale(12.8916 12.8531)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694566,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864161,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958573,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1949_54976",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(599.587 252.247) rotate(-74.1729) scale(5.48647 2.8785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51446,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947917,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1949_54976",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(600.644 248.579) rotate(106.26) scale(3.66238 1.92149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452654,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1949_54976",
    x1: 597.861,
    y1: 251.216,
    x2: 599.912,
    y2: 251.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1949_54976",
    x1: 602.402,
    y1: 247.407,
    x2: 605.625,
    y2: 248.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1949_54976",
    x1: 602.402,
    y1: 247.554,
    x2: 604.307,
    y2: 248.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1949_54976",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(586.205 252.247) rotate(-105.827) scale(5.48647 2.8785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51446,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947917,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1949_54976",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(585.148 248.579) rotate(73.7398) scale(3.66238 1.92149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.452654,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1949_54976",
    x1: 587.931,
    y1: 251.216,
    x2: 585.88,
    y2: 251.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1949_54976",
    x1: 583.39,
    y1: 247.407,
    x2: 580.167,
    y2: 248.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1949_54976",
    x1: 583.39,
    y1: 247.554,
    x2: 581.486,
    y2: 248.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1949_54976",
    x1: 606.065,
    y1: 251.509,
    x2: 604.263,
    y2: 256.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0780245,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376086,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1949_54976",
    x1: 579.978,
    y1: 251.509,
    x2: 581.779,
    y2: 256.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0780245,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376086,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1949_54976",
    x1: 604.423,
    y1: 255.697,
    x2: 602.648,
    y2: 252.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1949_54976",
    x1: 580.077,
    y1: 244.623,
    x2: 581.776,
    y2: 244.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1949_54976",
    x1: 605.965,
    y1: 244.623,
    x2: 604.266,
    y2: 244.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1949_54976",
    x1: 581.528,
    y1: 255.804,
    x2: 583.302,
    y2: 253.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1949_54976",
    x1: 583.845,
    y1: 256.587,
    x2: 587.352,
    y2: 253.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1949_54976",
    x1: 582.942,
    y1: 248.068,
    x2: 583.028,
    y2: 247.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1949_54976",
    x1: 582.966,
    y1: 248.081,
    x2: 583.05,
    y2: 247.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1949_54976",
    x1: 583.098,
    y1: 255.158,
    x2: 586.662,
    y2: 251.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1949_54976",
    x1: 582.951,
    y1: 248.075,
    x2: 583.038,
    y2: 247.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1949_54976",
    x1: 602.098,
    y1: 256.7,
    x2: 598.603,
    y2: 253.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1949_54976",
    x1: 603.602,
    y1: 248.068,
    x2: 603.518,
    y2: 247.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1949_54976",
    x1: 603.524,
    y1: 255.246,
    x2: 599.96,
    y2: 252.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4HeadphonesEarbuds);
export default __webpack_public_path__ + "static/media/4HeadphonesEarbuds.6f1dd3b3ebd72fa6c3ff3639a6da6091.svg";
export { ForwardRef as ReactComponent };